import React from 'react';

const ProfilePage = () => {
	return (
		<div className='ui container'>
			<div>
				<div>
					<h1>ProfilePage</h1>
					<div></div>
				</div>
			</div>
			<div></div>
		</div>
	);
};

export default ProfilePage;
